import { useContext } from "react";

import axios from "axios";

import { AppContext } from '~/contexts/AppContext';
import { MenuScreen } from '~/App';
import StyledButton from '~/components/StyledButton';
import StyledContentPanel from '~/components/StyledContentPanel';

import Fade from '~/components/Fade';
import { useTranslation } from "react-i18next";

const DeleteProfileAYSScreen: React.FC = () => {

    const { apiUrl, setMenuScreen } = useContext(AppContext)!;

    const { t } = useTranslation();

    const deleteProfile = async () => {
        await axios.delete(`${apiUrl}/user`);
        window.location.reload();
    };

    return (
        <div style={{ padding: '20px' }}>
            <Fade cascade>
                <StyledContentPanel>
                    <h1>{t('menu_profile_ays_title')}</h1>
                    <p>{t('menu_profile_ays_subtitle')}</p>
                </StyledContentPanel>
                <StyledButton style={{ backgroundColor: '#ff0000', color: 'white', marginTop: '20px', opacity: 0.8 }} onClick={deleteProfile}>
                    {t('menu_profile_ays_button_yes')}
                </StyledButton>
                <StyledButton onClick={() => setMenuScreen(MenuScreen.Profile)}>
                    {t('menu_profile_ays_button_no')}
                </StyledButton>
            </Fade>
        </div>
    );
}

export default DeleteProfileAYSScreen;